<template>
  <div :class="d._class" :id="d._title">
    <div class="container">
      <h3>{{d._title}}</h3>
      <div>
        <h2>{{d.article.title}}</h2>
        <br />
        ({{[d.author.name, d.author.apartment, d.author.company].filter(x => !!x).join(', ')}})
        <br />
        {{d.talkTime}}
        <br />
        <br />
        <p style="font-size:2em;">Abstract:</p>
        <br />
        <p class="paragraph">{{d.article.abstract}}</p>
        <br />
        <br />
        <p style="font-size:2em;">About the Speaker:</p>
        <br />
        <img
          :src="d.author.avatar"
          width="180"
          height="180"
          alt="avatar"
          class="img-responsive"
          style="float:left;"
        />
        <p style="font-size:1.5em;">{{d.author.brief}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Keynote",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          meta: {
            year: 2021,
            session: "third",
            date: "TBD",
            location: "TBD"
          },
          backgroundImage: ""
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "testimonials",
        _title: "Keynote",

        talkTime: "TBD",
        article: {
          title: "TBD",
          abstract: "TBD"
        },
        author: {
          avatar: "TBD",
          name: "TBD",
          apartment: "TBD",
          company: "TBD",
          address: "TBD",
          brief: "TBD"
        },
        
        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Keynote.vue